<template>
    <div class="preview" :style="pageStyle">
        <template v-if="content">
            <template v-if="content.pageType === 'HOME'">
                <div v-for="(item, index) in components" :key="item.id || index" class="preview-item">
                    <div v-if="item.type === 'searchBar'" class="search">{{ getProp(item, 'placeholder', '搜索商品') }}</div>

                    <div v-else-if="item.type === 'heroSwiper'" class="swiper">
                        <img v-if="firstImage(item)" :src="firstImage(item)" />
                    </div>

                    <div v-else-if="item.type === 'iconNav'" class="nav-grid">
                        <div v-for="(nav, navIndex) in getItems(item)" :key="navIndex" class="nav-item">
                            <div class="nav-icon">{{ getNavIcon(nav) }}</div>
                            <div class="nav-label">{{ nav.label || nav.title || '入口' }}</div>
                        </div>
                    </div>

                    <div v-else-if="item.type === 'sectionTitle'" class="section-title">
                        <div>
                            <div class="section-main">{{ getProp(item, 'title', '精选推荐') }}</div>
                            <div class="section-sub">{{ getProp(item, 'subtitle', '') }}</div>
                        </div>
                        <div class="section-more">{{ getProp(item, 'moreText', '更多') }}</div>
                    </div>

                    <div v-else-if="item.type === 'noticeBar'" class="notice-bar">
                        {{ getProp(item, 'text', '活动通知') }}
                    </div>

                    <div v-else-if="item.type === 'imageBanner'" class="image-banner">
                        <img v-if="getProp(item, 'imageUrl')" :src="getProp(item, 'imageUrl')" />
                    </div>

                    <div v-else-if="item.type === 'couponGrid'" class="coupon-grid">
                        <div class="block-title">{{ getProp(item, 'title', '领券专区') }}</div>
                        <div class="coupon-row">
                            <div v-for="(coupon, couponIndex) in getItems(item)" :key="couponIndex" class="coupon-card">
                                <div class="coupon-amount">¥{{ coupon.amount || coupon.value || 0 }}</div>
                                <div class="coupon-text">{{ coupon.title || `满${coupon.threshold || 0}可用` }}</div>
                            </div>
                        </div>
                    </div>

                    <div v-else-if="item.type === 'promotionCard'" class="promotion-card">
                        <div class="promotion-copy">
                            <div class="promotion-title">{{ getProp(item, 'title', '活动推荐') }}</div>
                            <div class="promotion-sub">{{ getProp(item, 'subtitle', '热门活动专区') }}</div>
                            <div class="promotion-btn">{{ getProp(item, 'buttonText', '立即查看') }}</div>
                        </div>
                        <img v-if="getProp(item, 'imageUrl')" :src="getProp(item, 'imageUrl')" class="promotion-image" />
                    </div>

                    <div v-else-if="item.type === 'richText'" class="rich-text">
                        {{ getProp(item, 'content', '文本说明区域') }}
                    </div>

                    <div v-else-if="item.type === 'blankSpace'" class="blank-space" :style="{ height: `${getProp(item, 'height', 24)}px` }"></div>

                    <div v-else-if="item.type === 'goodsList'" class="goods-block">
                        <div class="block-title">{{ getProp(item, 'title', '商品列表') }}</div>
                        <div class="goods-grid">
                            <div v-for="i in getProp(item, 'showCount', 4)" :key="i" class="goods-card">
                                <div class="goods-img"></div>
                                <div class="goods-name">示例商品 {{ i }}</div>
                                <div class="goods-price">¥99</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else>
                <div class="fixed-page">
                    <img v-if="config.bannerUrl || config.vipCardImage" :src="config.bannerUrl || config.vipCardImage" class="banner" />
                    <div class="fixed-title">{{ pageTitle }}</div>
                    <div class="fixed-text">{{ fixedText }}</div>
                    <div v-if="config.featureList && config.featureList.length" class="feature-list">
                        <div v-for="(feature, index) in config.featureList" :key="index" class="feature-item">
                            <div class="feature-dot"></div>
                            <div class="feature-copy">
                                <div class="feature-title">{{ feature.title || feature.name }}</div>
                                <div class="feature-sub">{{ feature.subtitle || feature.desc }}</div>
                            </div>
                        </div>
                    </div>
                    <button class="primary-btn" :style="{ backgroundColor: buttonColor }">{{ buttonText }}</button>
                </div>
            </template>
        </template>
        <a-empty v-else description="草稿 JSON 无法预览" />
    </div>
</template>

<script>
export default {
    name: 'MallV2Preview',
    props: {
        content: {
            type: Object,
            default: null
        }
    },
    computed: {
        components() {
            return this.content && this.content.components ? this.content.components : []
        },
        config() {
            return this.content && this.content.config ? this.content.config : {}
        },
        pageStyle() {
            return {
                backgroundColor: this.config.backgroundColor || '#f7f7f7'
            }
        },
        pageTitle() {
            const titleMap = {
                OPEN_CARD: '会员开卡',
                USER_CENTER: '个人中心',
                CART: '购物车'
            }
            return titleMap[this.content.pageType] || this.content.pageType
        },
        fixedText() {
            if (this.content.pageType === 'CART') {
                return this.config.emptyText || '购物车空空如也'
            }
            if (this.content.pageType === 'USER_CENTER') {
                return this.config.summaryText || '会员信息、订单和常用入口'
            }
            return this.config.tipText || '配置开卡字段与会员权益'
        },
        buttonText() {
            return this.config.buttonText || this.config.goShoppingText || '立即进入'
        },
        buttonColor() {
            return this.config.buttonColor || '#D64545'
        }
    },
    methods: {
        getProp(item, key, defaultValue) {
            return item && item.props && item.props[key] !== undefined ? item.props[key] : defaultValue
        },
        getItems(item) {
            return item && item.props && Array.isArray(item.props.items) ? item.props.items : []
        },
        getNavIcon(nav) {
            if (!nav) {
                return '•'
            }
            if (nav.icon) {
                return nav.icon.slice(0, 1).toUpperCase()
            }
            return '•'
        },
        firstImage(item) {
            const items = this.getItems(item)
            return items.length > 0 ? items[0].imageUrl : ''
        }
    }
}
</script>

<style scoped>
.preview {
    min-height: 596px;
    padding: 12px;
}

.preview-item {
    margin-bottom: 12px;
}

.search {
    height: 36px;
    line-height: 36px;
    padding: 0 16px;
    border-radius: 18px;
    background: #ffffff;
    color: #999999;
}

.swiper,
.image-banner {
    height: 170px;
    overflow: hidden;
    border-radius: 12px;
    background: #eeeeee;
}

.swiper img,
.image-banner img,
.banner {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.nav-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
    padding: 12px 8px;
    border-radius: 12px;
    background: #ffffff;
}

.nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.nav-icon {
    width: 44px;
    height: 44px;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    background: linear-gradient(135deg, #ff7a59, #ffb36b);
    font-weight: 700;
}

.nav-label {
    font-size: 12px;
    color: #333333;
}

.section-title {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 2px 4px;
}

.section-main {
    font-size: 16px;
    font-weight: 700;
    color: #222222;
}

.section-sub {
    margin-top: 2px;
    font-size: 12px;
    color: #999999;
}

.section-more {
    font-size: 12px;
    color: #d64545;
}

.notice-bar {
    padding: 10px 12px;
    border-radius: 12px;
    background: linear-gradient(135deg, #fff3ed, #fff9f2);
    color: #d64545;
    font-size: 13px;
}

.goods-block,
.coupon-grid {
    margin-top: 2px;
}

.block-title {
    margin-bottom: 8px;
    font-weight: 700;
    color: #222222;
}

.coupon-row {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
}

.coupon-card {
    padding: 10px 8px;
    border-radius: 12px;
    background: linear-gradient(180deg, #fff4ec, #ffffff);
    border: 1px solid #ffe0cc;
    text-align: center;
}

.coupon-amount {
    font-size: 18px;
    font-weight: 700;
    color: #d64545;
}

.coupon-text {
    margin-top: 4px;
    font-size: 12px;
    color: #8a4a2f;
}

.promotion-card {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 12px;
    border-radius: 16px;
    background: linear-gradient(135deg, #fff6f6, #fff);
    border: 1px solid #f0d6d6;
}

.promotion-copy {
    flex: 1;
}

.promotion-title {
    font-size: 16px;
    font-weight: 700;
    color: #222222;
}

.promotion-sub {
    margin-top: 4px;
    color: #777777;
    font-size: 12px;
}

.promotion-btn {
    display: inline-block;
    margin-top: 10px;
    padding: 6px 12px;
    border-radius: 999px;
    background: #d64545;
    color: #ffffff;
    font-size: 12px;
}

.promotion-image {
    width: 96px;
    height: 96px;
    border-radius: 12px;
    object-fit: cover;
    background: #eeeeee;
}

.rich-text {
    padding: 12px;
    border-radius: 12px;
    background: #ffffff;
    color: #555555;
    line-height: 1.7;
    white-space: pre-wrap;
}

.blank-space {
    width: 100%;
}

.goods-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
}

.goods-card {
    padding: 8px;
    border-radius: 12px;
    background: #ffffff;
}

.goods-img {
    height: 120px;
    border-radius: 10px;
    background: linear-gradient(135deg, #eeeeee, #dddddd);
}

.goods-name {
    margin-top: 8px;
    color: #333333;
    font-size: 13px;
}

.goods-price {
    color: #d64545;
    font-weight: 700;
}

.fixed-page {
    padding: 18px;
}

.banner {
    height: 160px;
    border-radius: 14px;
}

.fixed-title {
    margin-top: 20px;
    font-size: 20px;
    font-weight: 700;
}

.fixed-text {
    margin-top: 8px;
    color: #777777;
}

.feature-list {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.feature-item {
    display: flex;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 12px;
    background: #ffffff;
}

.feature-dot {
    width: 10px;
    height: 10px;
    margin-top: 6px;
    border-radius: 50%;
    background: #d64545;
    flex-shrink: 0;
}

.feature-copy {
    flex: 1;
}

.feature-title {
    font-size: 14px;
    font-weight: 600;
    color: #222222;
}

.feature-sub {
    margin-top: 2px;
    font-size: 12px;
    color: #888888;
}

.primary-btn {
    width: 100%;
    height: 42px;
    margin-top: 24px;
    border: 0;
    border-radius: 21px;
    color: #ffffff;
    font-weight: 600;
}
</style>
